module.exports = ".panel-group siterecord-comment + siterecord-comment {\n  display: block;\n  margin-top: 5px; }\n\ntextarea {\n  resize: vertical;\n  margin-bottom: 5px; }\n\n.button-bar {\n  margin-bottom: 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/comments/siterecord-comments.component.scss
// module id = ./src/app/shared/comments/siterecord-comments.component.scss
// module chunks = main